/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Language of the SMS or of the voice call
 */
export enum SendOtpBodyLocale {
  en = 'en',
  fr = 'fr'
}
